import { isChatChannelType } from 'ducks/channels/channelTypes'
import { doGraphqlRequest } from 'ducks/requests'
import { FETCH_CONVERSATION_COUNTS_FOR_CHANNEL } from '../actionTypes'

const ticketConversationCountForChannelQuery = `
  query ticketConversationCountForChannelQuery($channelId: String!) {
    node(id: $channelId) {
      ... on Channel {
        folders {
          nodes {
            id
            conversationCount
          }
        }
        tags {
          nodes {
            id
            conversationCount
          }
        }
        permittedAgents {
          nodes {
            id
            conversationCount
          }
        }
      }
    }
  }
`

const roomConversationCountForChannelQuery = `
  query roomConversationCountForChannelQuery($channelId: ID, $channelType: RoomChannelTypeEnum!) {
    roomsCounts(channelId: $channelId, channelType: $channelType) {
      lastUpdatedAt
      data {
        id
        conversationCount
        unreadCount
      }
    }
  }
`

function hackFolderCountsResponse(channelType) {
  return data => {
    if (isChatChannelType(channelType)) {
      const { roomsCounts: { lastUpdatedAt, data: folders } = {} } = data || {}
      return {
        data: {
          node: {
            folders: {
              // IMPORTANT: We dont currently have this available for the ticket conversation
              // counts. We'll need to extend the api to also expose this
              lastUpdatedAt,
              nodes: folders,
            },
            permittedAgents: { nodes: [] },
            tags: { nodes: [] },
          },
        },
      }
    }
    return data
  }
}

/*
  This method will be used to retrieve the conversation counts for a particular channel.
  Currently there is a massive disparity in the api implementation between tickets and
  rooms. This method will hide those differences and return a standadised interface for
  the folder component.
 */
export function doFetchFolderCounts({ channelId, channelType }) {
  return doGraphqlRequest(
    FETCH_CONVERSATION_COUNTS_FOR_CHANNEL,
    isChatChannelType(channelType)
      ? roomConversationCountForChannelQuery
      : ticketConversationCountForChannelQuery,
    {
      channelId,
      channelType: channelType.toUpperCase(),
    },
    {
      app: true,
      transformResponse: hackFolderCountsResponse(channelType),
      meta: {
        channelType,
      },
    }
  )
}
